/* esm.sh - applesauce-core@5.2.0/dist/helpers/tags */
export * from "/*applesauce-core@5.2.0/esnext/dist/helpers/tags.mjs";
